import { render, staticRenderFns } from "./Hotspots.vue?vue&type=template&id=cd9ce3d6&scoped=true&"
import script from "./Hotspots.vue?vue&type=script&lang=js&"
export * from "./Hotspots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9ce3d6",
  null
  
)

export default component.exports